var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFehler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.225,
    height: 18.322,
    viewBox: "0 0 19.225 18.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Fehler",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3283",
    "data-name": "Gruppe 3283",
    transform: "translate(3.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_391",
    "data-name": "Pfad 391",
    d: "M947.5,523.822l1.672-6.239.542-2.235L951.737,507h3.794l1.926,8.348.472,2.046,1.522,6.428Z",
    transform: "translate(-947.5 -507)",
    fill: "none",
    stroke: "#ec5867",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_392",
    "data-name": "Pfad 392",
    d: "M955.129,540.5h7.589l.506,2.024-8.474-.126Z",
    transform: "translate(-949.375 -532.026)",
    fill: "#ec5867"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_393",
    "data-name": "Pfad 393",
    d: "M959.006,522.5h5.565l.506,2.024H958.5Z",
    transform: "translate(-952.176 -518.579)",
    fill: "#ec5867"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_118",
    "data-name": "Linie 118",
    x2: 19.225,
    transform: "translate(0 16.822)",
    fill: "none",
    stroke: "#ec5867",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFehler);
export default __webpack_public_path__ + "static/media/icon_Fehler.1bae8c945cad00535b4b86a7ce653d06.svg";
export { ForwardRef as ReactComponent };